module.exports = __webpack_public_path__ + "static/media/polyplastics.e163d126.svg";